import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { RowEventEmit } from "../../events-screen/event-page-models/row-event-emit";
import { trimTextByWord } from "../../events-screen/utils/trimTextByWord";
import { PaperPaymentItemBatch } from "../receipt-page-models/PaperPaymentItem";
import { Epoc } from "../../../_models/Epoc";
import { PaperPaymentType } from "../receipt-page-models/PaperPaymentType";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { GeneralRowEvent } from "../../../_models/general-row-event";
import { ReceiptTableRowHeader } from "../receipt-table-row-header/receipt-table-row-header.component";
import { DepositRowAction } from "../receipt-page-models/DepositRowAction";
import { DateAndTimeUtils } from "../../../_helpers/dateUtils";

@Component({
  selector: "receipt-table-row",
  templateUrl: "./receipt-table-row.component.html",
  styleUrls: ["./receipt-table-row.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          maxHeight: "1500px",
          opacity: 1,
          overflow: "visible",
        })
      ),
      state(
        "closed",
        style({
          maxHeight: "1px",
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class ReceiptTableRowComponent {
  public static ReceiptTableRowMenuOptions: Array<{
    action: string;
    text: string;
    customIcon?: string;
  }> = [
    {
      action: "deposit",
      text: "הפקדה",
      customIcon: "bankDeposit",
    },
    { action: "viewReceipt", text: "צפייה בקבלה", customIcon: "viewReceipt" },
    { action: "delete", text: "ביטול קבלה" },
  ];
  public ReceiptTableRowMenuOptions =
    ReceiptTableRowComponent.ReceiptTableRowMenuOptions;
  @Input("openPaymentBatchCode") public openPaymentBatchId: number;
  @Output("rowEvent") public rowEvent: EventEmitter<
    GeneralRowEvent<DepositRowAction>
  > = new EventEmitter<GeneralRowEvent<DepositRowAction>>();
  public PaperPaymentType = PaperPaymentType;
  public isSingleItemInBatch: boolean = true;
  public isPartialDeposit: boolean = false;
  public isMultiDate: boolean = false;
  public translations$: Observable<ITranslations>;
  public batchPaymentHeader = ReceiptTableRowHeader.BatchPaymentHeader;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }

  public _paymentBatch: PaperPaymentItemBatch;

  @Input() public set paymentBatch(value: PaperPaymentItemBatch) {
    this._paymentBatch = value;
    this.isSingleItemInBatch =
      value.paymentsItems && value.paymentsItems.length === 1;
    this.isPartialDeposit = value.isPartiallyDeposit;
    this.isMultiDate =
      new Set(value.paymentsItems.map((p) => p.receiptDate)).size > 1;
  }

  public stringFromEpoc(epoc: Epoc) {
    const date = DateAndTimeUtils.serverEpochToDate(epoc);
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }

  public rowClicked($event): void {
    const action =
      this._paymentBatch.id === this.openPaymentBatchId ? "close" : "open";
    this.rowEvent.emit({
      action,
      eventId: this._paymentBatch.id.toString(),
      eventObject: {
        depositActionType: "none",
        batchId: this._paymentBatch.id,
        paymentItemId: null,
      },
    });
  }

  public menuEventHandler($event: RowEventEmit) {
    switch ($event.action) {
      case "delete":
        this.rowEvent.emit({
          action: $event.action as any,
          eventId: this._paymentBatch.id.toString(),
          eventObject: {
            depositActionType: "delete",
            batchId: this._paymentBatch.id,
            paymentItemId: this._paymentBatch.paymentsItems[0].id,
          },
        });
        break;
      case "depositBatch" as any:
        this.rowEvent.emit({
          action: $event.action as any,
          eventId: this._paymentBatch.id.toString(),
          eventObject: {
            depositActionType: "depositBatch",
            batchId: this._paymentBatch.id,
            paymentItemId: null,
          },
        });
        break;
      default:
        this.rowEvent.emit({
          action: $event.action as any,
          eventId: this._paymentBatch.id.toString(),
          eventObject: {
            depositActionType: $event.action as any,
            batchId: this._paymentBatch.id,
            paymentItemId: null,
          },
        });

        return;
    }
  }

  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }

  public batchDepositClicked($event: MouseEvent) {
    $event.stopPropagation();
    this.rowEvent.emit({
      action: "edit",
      eventId: this._paymentBatch.id.toString(),
      eventObject: {
        depositActionType: "depositBatch",
        batchId: this._paymentBatch.id,
        paymentItemId: null,
      },
    });
  }

  protected oneItemRowEventHandler($event: GeneralRowEvent<DepositRowAction>) {
    const itemRowEvent = { ...$event };
    if (itemRowEvent.eventObject && !itemRowEvent.eventObject.batchId) {
      itemRowEvent.eventObject.batchId = this._paymentBatch.id;
    }
    this.rowEvent.emit($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-table-row/receipt-table-row.component.ts